/* EditDropdown.tsx generated by @compiled/babel-plugin v0.38.1 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "./EditDropdown.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl-next';
import { fg } from '@atlaskit/platform-feature-flags';
import Select, { AsyncSelect, components } from '@atlaskit/select';
import { getInputAccessibilityDescriptionId } from '../common/accessibilityUtils';
import { getDropDownMenuPosition } from '../common/commonDropDownMenuProps';
import { SelectErrorContainer } from '../common/questionWrappers';
import { EditOtherOption } from './EditOtherOption';
import { messages } from './messages';
var menuStyles = {
  menu: "_1pbyni7l"
};
export var EditDropdown = function EditDropdown(_ref) {
  var id = _ref.id,
    errorId = _ref.errorId,
    descriptionId = _ref.descriptionId,
    options = _ref.options,
    value = _ref.value,
    loading = _ref.loading,
    loadOptions = _ref.loadOptions,
    onChange = _ref.onChange,
    hasOtherOption = _ref.hasOtherOption,
    otherOptionSelected = _ref.otherOptionSelected,
    otherOptionText = _ref.otherOptionText,
    onOtherOptionTextChange = _ref.onOtherOptionTextChange,
    isInvalid = _ref.isInvalid,
    isRequired = _ref.isRequired,
    customComponents = _ref.customComponents,
    label = _ref.label;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hasBeenFocused = _useState2[0],
    setHasBeenFocused = _useState2[1];
  if (loadOptions === undefined) {
    return /*#__PURE__*/React.createElement(SelectErrorContainer, {
      isInvalid: isInvalid
    }, /*#__PURE__*/React.createElement(Select, _extends({
      inputId: fg('jsm-accessibility-fixes') ? id : undefined,
      id: fg('jsm-accessibility-fixes') ? undefined : id,
      descriptionId: fg('jsm-accessibility-fixes') ? getInputAccessibilityDescriptionId(errorId, descriptionId, isInvalid) : undefined,
      options: options,
      value: value !== null && value !== void 0 ? value : null,
      isLoading: loading,
      onChange: onChange,
      isSearchable: true,
      noOptionsMessage: function noOptionsMessage() {
        return /*#__PURE__*/React.createElement(FormattedMessage, messages.choiceDropdownNoOptions);
      },
      placeholder: /*#__PURE__*/React.createElement(FormattedMessage, messages.choiceDropdownSelect),
      isRequired: isRequired
    }, getDropDownMenuPosition(), {
      label: label
    }, fg('jsm-request-intake-jac-fixes') ? {
      components: {
        Menu: function Menu(props) {
          return /*#__PURE__*/React.createElement(components.Menu, _extends({}, props, {
            xcss: menuStyles.menu
          }));
        }
      }
    } : {})), hasOtherOption && otherOptionSelected && /*#__PURE__*/React.createElement(EditOtherOption, {
      dropdown: true,
      value: otherOptionText,
      isDisabled: !otherOptionSelected,
      onChange: onOtherOptionTextChange,
      id: id
    }));
  }
  return /*#__PURE__*/React.createElement(SelectErrorContainer, {
    isInvalid: isInvalid
  }, /*#__PURE__*/React.createElement(AsyncSelect, _extends({
    inputId: fg('jsm-accessibility-fixes') ? id : undefined,
    id: fg('jsm-accessibility-fixes') ? undefined : id,
    descriptionId: fg('jsm-accessibility-fixes') ? getInputAccessibilityDescriptionId(errorId, descriptionId, isInvalid) : undefined,
    autoFocus: hasBeenFocused,
    defaultMenuIsOpen: hasBeenFocused,
    defaultOptions: hasBeenFocused,
    isSearchable: true,
    key: id + hasBeenFocused,
    isLoading: loading,
    noOptionsMessage: function noOptionsMessage() {
      return /*#__PURE__*/React.createElement(FormattedMessage, messages.choiceDropdownNoOptions);
    },
    loadOptions: loadOptions,
    loadingMessage: function loadingMessage() {
      return /*#__PURE__*/React.createElement(FormattedMessage, messages.choiceDropdownLoading);
    }
  }, getDropDownMenuPosition(), {
    onChange: onChange,
    onFocus: function onFocus() {
      return setHasBeenFocused(true);
    },
    placeholder: /*#__PURE__*/React.createElement(FormattedMessage, messages.choiceDropdownSelect),
    value: value !== null && value !== void 0 ? value : null,
    components: fg('jsm-request-intake-jac-fixes') ? _objectSpread(_objectSpread({}, customComponents), {}, {
      Menu: function Menu(props) {
        return /*#__PURE__*/React.createElement(components.Menu, _extends({}, props, {
          xcss: menuStyles.menu
        }));
      }
    }) : customComponents,
    label: label
  })));
};